<template>
  <div class="modal-email">
    <div class="modal-header">
      <h3 class="title">Kreiraj email</h3>
    </div>
    <div class="content">
      <div class="to">
        <div class="to-wrapper" ref="dropdown" @click="showDropdown = true">
          <div class="no-emails" v-if="getSelectedMembers.length == 0">
            Izaberite primaoce
          </div>
          <template v-if="getSelectedMembers.length > 0">
            <div
              class="email-bubble"
              v-for="member in getSelectedMembers"
              :key="member.email"
              @click="$event.stopPropagation()"
            >
              {{ member.email }}
              <i
                class="fas fa-times bubble-x"
                @click="handleBubbleRemove(member, $event)"
              ></i>
            </div>
          </template>
        </div>
        <div
          class="dropdown"
          v-click-outside="closeDropdown"
          v-if="showDropdown"
        >
          <div class="input-wrapper">
            <input
              placeholder="Pretraži"
              v-model="searchCriteria"
              rows="1"
              class="form-control to-input"
              type="text"
            />
            <button
              class="btn btn--dropdown btn--select"
              @click="handleSelectButton"
            >
              Izaberi sve
            </button>
          </div>
          <div class="members-wrapper">
            <div class="empty-list" v-if="getMembers.length == 0">
              Nema rezultata
            </div>
            <template v-if="getMembers.length > 0">
              <div
                class="member"
                @click="handleCheckboxChange(member)"
                v-for="member in getMembers"
                :key="member.id"
              >
                <div class="basic">
                  <span class="name">{{ member.full_name }}</span>
                  <span class="email">{{ member.email }}</span>
                </div>
                <div class="empty-space"></div>
                <span class="desc">{{ member.div_description }}</span>
                <checkbox
                  class="desc-cb"
                  size="small"
                  :checked="member.checked"
                  @change="handleCheckboxChange(member)"
                ></checkbox>
              </div>
            </template>
          </div>
        </div>
      </div>
      <input
        type="text"
        placeholder="Naslov"
        class="form-control margin-bottom-1"
        v-model="emailSubject"
      />
      <textarea
        class="form-control"
        rows="3"
        placeholder="Sadržaj"
        v-model="emailBody"
      ></textarea>
      <div class="upload-area">
        <upload-button
          class="upload-btn"
          @files-selected="getFiles"
          ref="uploadBtn"
        ></upload-button>
        <div class="uploaded">
          <div v-if="attachments.length == 0" class="no-files">
            <div class="upload-wrapper" @click="addFile">
              <svg
                class="upload-icon pointer-cursor"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="33"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <label class="upload-text pointer-cursor"
                >Izaberite datoteku</label
              >
            </div>
          </div>
          <div v-else>
            <div class="file" v-for="(file, index) of attachments" :key="index">
              <p>{{ file.name }}</p>
              <i
                class="fas fa-times del--mod"
                @click="removeUploadedFile(index)"
              ></i>
            </div>
            <div
              class="email-upload-more-wrapper pointer-cursor"
              @click="addMoreFiles"
            >
              <svg
                class
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <span class>Dodaj datoteku</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <transition enter-active-class="animated shake">
        <div v-if="errorMsg.length > 0" class="error">{{ errorMsg }}</div>
      </transition>
      <button type="submit" class="btn btn-danger" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="sendEmails"
        :disabled="isLoading"
      >
        <div v-if="!isLoading">Pošalji</div>
        <div v-else>
          <spinner size="20" line-fg-color="#00796b" class="spinner"></spinner>
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { financesInstance } from '@/axios/axios';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';
import checkbox from '@/components/common/Checkbox';
export default {
  name: 'EmailModal',
  created() {
    financesInstance
      .get(`communities/${this.$store.getters.getActiveCommunity.id}/members`)
      .then(res => {
        for (let member of res.data.members) {
          member.checked = false;
        }
        this.members = res.data.members.filter(member => {
          return member.email != '';
        });
      })
      .catch(() => {});
  },
  components: {
    uploadButton,
    checkbox
  },
  computed: {
    getSelectedMembers() {
      return this.members.filter(member => {
        if (member.checked) {
          return member;
        }
      });
    },
    getMembers() {
      if (this.searchCriteria == '') {
        return this.members;
      }

      return this.members.filter(member => {
        const searchCriteria = this.searchCriteria
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        const name = member.full_name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        const email = member.email.toLowerCase();
        const description = member.div_description
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

        if (
          name.indexOf(searchCriteria) > -1 ||
          email.indexOf(searchCriteria) > -1 ||
          description.indexOf(searchCriteria) > -1
        )
          return member;
      });
    }
  },
  data() {
    return {
      members: [],
      attachments: [],
      selection: true,
      searchCriteria: '',
      showDropdown: false,
      emailSubject: '',
      emailBody: '',
      errorMsg: '',
      isLoading: false,
      removingFile: false
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    getFiles(load) {
      for (const l of load) {
        this.attachments.push(l);
      }
    },
    addFile() {
      if (this.attachments.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.$refs.uploadBtn.openFileSelect();
      return;
    },
    addMoreFiles() {
      this.$refs.uploadBtn.openFileSelect();
    },
    removeUploadedFile(index) {
      this.removingFile = true;
      this.attachments.splice(index, 1);
    },
    handleCheckboxChange(member) {
      member.checked = !member.checked;
    },
    handleSelectButton() {
      for (const member of this.getMembers) {
        member.checked = this.selection;
      }
      this.selection = !this.selection;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    handleBubbleRemove(member, event) {
      event.stopPropagation();
      member.checked = false;
    },
    sendEmails() {
      this.errorMsg = '';
      if (this.isLoading || !this.validateInput()) {
        return;
      }
      this.isLoading = true;

      financesInstance
        .post(
          `communities/${this.$store.getters.getActiveCommunity.id}/email`,
          this.formatMediaForSubmit(),
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(() => {
          this.showSuccessModal();
          this.emailSubject = '';
          this.emailBody = '';
          this.closeModal();
        })
        .catch(() => {
          this.showFailModal();
        })
        .finaly(() => {
          this.isLoading = false;
        });
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      for (let i = 0; i < this.attachments.length; i++) {
        fd.append('attachments', this.attachments[i], this.attachments[i].name);
      }
      fd.append('emailBody', this.emailBody);
      fd.append('emailSubject', this.emailSubject);
      fd.append('to', this.getSelectedEmails());
      return fd;
    },
    validateInput() {
      return (
        !this.isEmpty(
          this.getSelectedMembers,
          'Biranje primaoca je obavezno'
        ) && !this.isEmpty(this.emailSubject, 'Naslov je obavezan')
      );
    },
    getSelectedEmails() {
      const emails = [];
      for (let member of this.getSelectedMembers) {
        emails.push(member.email);
      }
      return emails;
    },
    isEmpty(element, errorMsg) {
      let isEmpty = false;
      if (Array.isArray(element)) {
        isEmpty = element.length == 0;
      } else if (typeof element == 'string') {
        isEmpty = element == '';
      } else {
        throw new Error(
          '[isEmpty] Unsupported type. Array or string are expected'
        );
      }
      if (isEmpty) {
        this.errorMsg = errorMsg;
      }
      return isEmpty;
    }
  },
  directives: {
    'click-outside': {
      priority: 700,
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = event => {
          if (
            !(
              el == event.target ||
              el.contains(event.target) ||
              vnode.context.$refs.dropdown.contains(event.target)
            )
          ) {
            vnode.context[binding.expression]();
          }
        };

        el.handleEscapeKey = event => {
          if (event.key === 'Escape') {
            vnode.context[binding.expression]();
          }
        };

        document.body.addEventListener('click', el.clickOutsideEvent);
        document.body.addEventListener('touchstart', el.clickOutsideEvent);
        document.body.addEventListener('keyup', el.handleEscapeKey);
      },
      unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.body.removeEventListener('touchstart', el.clickOutsideEvent);
        document.body.addEventListener('keyup', el.handleEscapeKey);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-email {
  .modal-header {
    h3 {
      color: rgb(46, 45, 45);
    }
  }

  .content {
    padding: 1.5rem 0;
    .margin-bottom-1 {
      margin-bottom: 1rem;
    }
    .to {
      margin-bottom: 1.5rem;
      position: relative;

      .to-wrapper {
        border: 1px solid #ced4da;
        border-radius: 4px;
        min-height: 38px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 5px;
        .no-emails {
          color: rgb(88, 88, 88);
        }
        .email-bubble {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 40px;
          border: 1px solid var(--primary-color);
          font-weight: 900;
          font-size: 12px;
          z-index: 5;
          max-height: 24px;
          color: rgb(88, 88, 88);
          margin: 4px 0;
          .bubble-x {
            padding-left: 5px;
          }
          .bubble-x:hover {
            color: black;
            cursor: pointer;
          }
        }

        .email-bubble:hover {
          cursor: default;
        }

        .email-bubble:not(:first-of-type) {
          margin-left: 5px;
        }
      }

      .to-wrapper {
        cursor: text;
      }

      .dropdown {
        position: absolute;
        border-radius: 4px;
        border: 1px solid #ced4da;
        background-color: white;
        min-width: 60%;
        max-width: 100%;
        // box-shadow: 0 1px 2px 2px rgba(60, 64, 67, 0.149);
        .input-wrapper {
          position: relative;
          .to-input {
            border: none;
            border-radius: 0;
            width: 100%;
            background-color: #f5f5f54d;
          }

          .to-input:focus {
            box-shadow: none;
          }

          .btn--dropdown {
            position: absolute;
            top: 3px;
            right: 10px;
            font-size: 12px;
            width: 80px;
            height: 30px;
            text-align: center;
            background-color: transparent;
          }

          .btn--dropdown:focus,
          .btn--dropdown:active {
            outline: none;
            box-shadow: none;
          }

          .btn--select {
            border: 1px solid var(--primary-color);
            color: black;
          }

          .btn--select:hover {
            background-color: var(--primary-color);
            color: white;
          }
        }

        .members-wrapper {
          max-height: 190px;
          overflow-y: auto;

          .member {
            padding: 5px 5px;
            display: flex;
            justify-content: space-between;
            position: relative;
            .basic {
              display: flex;
              flex-direction: column;
              .email {
                font-size: 15px;
                color: #5e5e5e;
              }
            }

            .empty-space {
              width: 50px;
            }

            .description {
              display: flex;
              flex-direction: column;
              position: relative;
              // align-items: flex-end;
              .desc {
                color: #424242;
                font-size: 16px;
              }
            }
            .desc-cb {
              position: absolute;
              bottom: 25px;
              right: 20px;
              padding-left: 0;
              margin-bottom: 0;
            }
          }

          .empty-list {
            height: 35px;
            padding: 5px;
          }
        }

        .member:hover {
          background-color: #ececec;
          cursor: pointer;
        }
      }
    }

    .upload-area {
      margin-top: 5px;
      padding: 5px 0;

      .no-files {
        padding: 0 5px;
      }
      .uploaded {
        background-color: rgb(241, 241, 241);
        border-radius: 4px;
      }
      .file {
        font-size: 15px;
        width: 100%;
        display: inline-flex;
        align-items: center;
        padding: 0 5px;
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 2px;
        }

        .del--mod {
          margin-left: auto;

          cursor: pointer;
          color: red;
        }
      }

      .file:not(:last-of-type) {
        border-bottom: solid 1px lightgray;
      }
    }
  }

  .modal-footer {
    padding: 1rem 0;

    .error {
      margin-right: auto;
      color: red;
    }

    .btn--mod {
      min-width: 71px;
      min-height: 38px;
    }
  }
}
</style>
